// components/VideoPlayer/SubtitleButtons/SubtitleButtons.jsx

import React, { useState } from "react";
import WordInfoModal from "../WordInfoModal/WordInfoModal";
import "./SubtitleButtons.css";

const TRANSLATE_SERVICES = {
  bing: {
    name: "Bing",
    icon: "/icons/bing.png",
    getUrl: (fromLang, toLang, text) =>
      `https://www.bing.com/translator/?from=${fromLang}&to=${toLang}&text=${encodeURIComponent(text)}`,
  },
  google: {
    name: "Google Translate",
    icon: "/icons/google.png",
    getUrl: (fromLang, toLang, text) =>
      `https://translate.google.com/?sl=${fromLang}&tl=${toLang}&text=${encodeURIComponent(text)}&op=translate`,
  },
  glosbe: {
    name: "Glosbe",
    icon: "/icons/glosbe.png",
    getUrl: (fromLang, toLang, text) =>
      `https://glosbe.com/${fromLang}/${toLang}/${encodeURIComponent(text)}`,
  },
};

export const TranslateButton = ({
  subtitleNumber,
  fromLang,
  toLang = "fa",
  text,
  service = "bing",
  onOpen,
}) => {
  const handleClick = () => {
    const serviceConfig = TRANSLATE_SERVICES[service];
    if (!serviceConfig || !text) return;

    // برای زیرنویس دوم، زبان‌ها جابجا میشن
    const actualFromLang = subtitleNumber === 1 ? fromLang : toLang;
    const actualToLang = subtitleNumber === 1 ? toLang : fromLang;

    const url = serviceConfig.getUrl(actualFromLang, actualToLang, text);

    // باز کردن پاپ‌آپ
    const width = 800;
    const height = 600;
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;

    window.open(
      url,
      `translate-${service}`,
      `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`,
    );

    if (onOpen) onOpen();
  };

  const serviceConfig = TRANSLATE_SERVICES[service];
  if (!serviceConfig) return null;

  return (
    <button
      className="subtitle-btn translate-btn"
      onClick={handleClick}
      title={`ترجمه با ${serviceConfig.name}`}
    >
      <img src={serviceConfig.icon} alt={serviceConfig.name} />
    </button>
  );
};

export const SaveButton = ({
  text,
  fromLang,
  toLang = "fa",
  subtitle1Text,
  subtitle2Text,
  movieName,
  season,
  episode,
  onOpen,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClick = () => {
    setIsModalOpen(true);
    if (onOpen) onOpen();
  };

  return (
    <>
      <button
        className="subtitle-btn save-btn"
        onClick={handleClick}
        title="ذخیره جمله"
      >
        <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
          <path d="M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2z" />
        </svg>
      </button>

      <WordInfoModal
        isOpen={isModalOpen}
        word={text} // اینجا جمله به عنوان کلمه نمایش داده میشه
        fullText={text}
        onClose={() => setIsModalOpen(false)}
        fromLang={fromLang}
        toLang={toLang}
        movieName={movieName}
        season={season}
        episode={episode}
        subtitle1Text={subtitle1Text}
        subtitle2Text={subtitle2Text}
        isSentenceMode={true} // پرچم جدید برای حالت جمله
      />
    </>
  );
};
